import { render, staticRenderFns } from "./ScreenshotViewer.vue?vue&type=template&id=3fef572a&scoped=true"
import script from "./ScreenshotViewer.vue?vue&type=script&lang=js"
export * from "./ScreenshotViewer.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotViewer.vue?vue&type=style&index=0&id=3fef572a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef572a",
  null
  
)

export default component.exports